import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import TopAppBar from "../common_components/app_bar_options.component";
import BottomBar from "../common_components/bottom_bar_options.component";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@material-ui/core/Button";
import Badge from "@material-ui/core/Badge";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import LinearProgress from "@material-ui/core/LinearProgress";
import ImageNotFound from "../../assets/img/logo-black-img-not-found.png";
import { Link } from "react-router-dom";
import axiosConfig from "../axiosConfig";
import requireSub from "../common_components/requireAuthorized";
import { withRouter } from "react-router-dom";
import logo from "../../assets/img/cw_logo.png";

const styles = {
  root: {
    flexGrow: 1,
    paddingTop: "5%",
    backgroundColor: "white",
  },
  formControl: {
    minWidth: "16%",
    height: "20%",
    marginLeft: "1%",
    marginRight: "1%",
    "@media (min-width:200px)": {
      minWidth: "25%",
    },
    "@media (min-width:600px)": {
      minWidth: "20%",
    },
    "@media (min-width:960px)": {
      minWidth: "16%",
    },
  },
  input: {
    padding: "10px",
    border: "1px solid",
    borderRadius: 2,
    "&:before": {
      borderColor: "red",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  search_icon: {
    color: "#707070",
  },
  select: {
    border: "1px solid",
    borderRadius: 2,
    borderColor: "#707070",
    "&:before": {
      borderColor: "red",
    },
    "&:after": {
      borderColor: "white",
    },
  },
  card: {
    minWidth: 275,
    width: "12%",
    minheight: 100,
    "@media (min-width:200px)": {
      height: 270,
      width: "8%",
      marginTop: 20,
    },
    "@media (min-width:600px)": {
      height: 280,
      width: "10%",
      marginTop: 20,
    },
    "@media (min-width:960px)": {
      height: 310,
      width: "12%",
    },
  },
  card_title: {
    fontSize: "3rem",
    "white-space": "nowrap",
    overflow: "hidden",
    "text-overflow": "ellipsis",
    "@media (min-width:200px)": {
      fontSize: "1.25rem",
    },
    "@media (min-width:600px)": {
      fontSize: "1.25rem",
    },
    "@media (min-width:960px)": {
      fontSize: "1.5rem",
    },
  },
  small_image_size: {
    height: 70,
    "@media (min-width:200px)": {
      height: 110,
    },
    "@media (min-width:600px)": {
      height: 130,
    },
    "@media (min-width:960px)": {
      height: 150,
    },
  },
  edit_icon: {
    color: "#F6227F",
  },
  button_size: {
    padding: 0,
    marginTop: 10,
    maxHeight: 20,
    maxWidth: 10,
    minHeight: 25,
    minWidth: 25,
    textAlign: "right",
  },
  text_title: {
    fontSize: "3rem",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
};

class LeafLibrary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plant_type: [],
      product_type: [],
      cannabinoid: [],
      selected_plant: "",
      selected_product: "",
      selected_cana: "",
      badgeCount: 0,
      data: [],
      config_data: [],
      dialog: false,
      loading: true,
      current_page: 1,
      products_per_page: 9,
    };

    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleOpenDelete = this.handleOpenDelete.bind(this);
    this.handleCloseDelete = this.handleCloseDelete.bind(this);
    this.getData();
  }

  getData() {
    let brand_id = sessionStorage.getItem("brand_id");
    let token = sessionStorage.getItem("token");
    if (!brand_id && !token) {
      // console.log("Im IN");
      this.props.history.push("/login");
    } else {
      // console.log("BRAND ID IS", brand_id, token);
      try {
        axiosConfig
          .get(`/brand/${brand_id}`)
          .then((product_response) => {
            // console.log("BRAND IS: ", product_response);
            axiosConfig
              .get("/configuration/listProductComboField/")
              .then((config_response) => {
                // console.log( config_response)
                this.loadData(product_response.data.products, config_response);
              })
              .catch((err) => {
                // console.log(err);
                // console.log(err.response);
                alert("Unexpected Error");
                // this.setState({loading: false})
              });
          })
          .catch((err) => {
            // console.log(err);
            // console.log(err.response);
            alert("Unexpected Error");
            // this.setState({loading: false})
          });
      } catch (err) {
        // console.log(err);
        // console.log(err.response);
      }
    }
  }

  componentWillMount() {
    document.title = "Leaf Library | CanaWho";
  }

  loadData(product_response, config_response) {
    this.setState({ loading: true });
    var plant_type = [],
      prod_type = [];
    config_response.data.usage_period.map((data) => {
      plant_type.push(data);
    });

    config_response.data.form_type.map((data) => {
      data.type.map((data) => {
        prod_type.push(data.name);
      });
    });
    // console.log(config_response.data.usage_period);

    this.setState({
      data: product_response,
      plant_type: plant_type,
      product_type: prod_type,
      cannabinoid: config_response.data.cannabinoid,
      config_data: config_response.data,
      loading: false,
    });
  }

  addDefaultSrc(ev) {
    ev.target.src = ImageNotFound;
  }

  clearOptions() {
    this.setState({
      selected_plant: "",
      selected_product: "",
      selected_cana: "",
    });
    this.getData();
  }

  handleOpenDelete(id, brandId) {
    this.setState({
      deleteId: id,
      brandId: brandId,
      dialog: true,
    });
  }

  goToProduct(id) {
    // console.log(id);
    localStorage.setItem("productId", `${id}`);
    setTimeout(function () {
      //use in dev
      // window.location.assign("http://localhost:3000/company/product");
      window.location.assign("https://www.canawho.com/company/product");
    }, 1500);
  }

  handleCloseDelete() {
    this.setState({
      deleteId: "",
      brandId: "",
      dialog: false,
    });
  }

  filterProduct() {
    const { selected_plant, selected_product, selected_cana } = this.state;
    if ((selected_plant, selected_product, selected_cana)) {
      let brand_id = sessionStorage.getItem("brand_id");
      const filter = [];
      if (selected_plant) filter.push(selected_plant);
      if (selected_product) filter.push(selected_product);
      if (selected_cana) filter.push(selected_cana);
      // console.log(filter)
      axiosConfig
        .post("/product/listByFields", { filter: filter })
        .then((response) => {
          // console.log(response.data);
          var filteredProducts = response.data.filter(
            (e) => e.brand_id === brand_id
          );
          this.setState({ data: filteredProducts });
        })
        .catch((error) => {
          // console.log(error);
          // console.log(error.response);
        });
    }
  }

  deleteForm() {
    const { deleteId, brandId } = this.state;
    this.setState({ dialog: false });
    let brand_id = sessionStorage.getItem("brand_id");
    axiosConfig
      .delete(`/product/${brand_id}/${deleteId}`)
      .then((respo) => {
        // console.log(respo);
        this.updateStateAfterDelete(deleteId);
      })
      .catch(function (error) {
        // console.log(error.response);
        //TODO: Show errors with snackbars
      });
  }

  updateStateAfterDelete(id) {
    alert("Deleted!");
    this.setState({
      data: this.state.data.filter((p) => p._id !== id),
      deleteId: "",
      brandId: "",
    });
  }

  handlePageClick(number) {
    this.setState({ current_page: number });
  }

  render() {
    const { classes } = this.props;
    const {
      plant_type,
      product_type,
      cannabinoid,
      data,
      loading,
      selected_plant,
      selected_product,
      selected_cana,
      dialog,
      current_page,
      products_per_page,
    } = this.state;
    var badge_counter = 0;
    if (selected_plant) badge_counter++;
    if (selected_product) badge_counter++;
    if (selected_cana) badge_counter++;

    // Logic for displaying current todos
    const index_last_product = current_page * products_per_page;
    const index_first_product = index_last_product - products_per_page;
    const current_products =
      current_page === 0
        ? data
        : data.slice(index_first_product, index_last_product);

    const page_numbers = [];
    for (let i = 1; i <= Math.ceil(data.length / products_per_page); i++) {
      page_numbers.push(i);
    }

    // console.log(data);

    const render_page = page_numbers.map((number) => {
      return (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => this.handlePageClick(number)}
          style={{
            color: current_page === number ? "white" : "#F6227F",
            background: current_page === number ? "#F6227F" : "white",
            margin: "0.5%",
            marginTop: "1%",
          }}
        >
          {number}
        </Button>
      );
    });

    const render_products = current_products.map((item, index) => {
      return (
        <Grid item md={4} align="center">
          <Card className={classes.card} raised={true}>
            <CardContent>
              <img
                alt=""
                className={classes.small_image_size}
                src={item.image[0]}
                onError={this.addDefaultSrc}
              />
              <h1
                style={{ textAlign: "left", marginLeft: 16 }}
                className={classes.card_title}
              >
                {item.name}
              </h1>
              <Typography
                variant="h4"
                style={{
                  color: "black",
                  fontFamily: "Open Sans",
                  textAlign: "left",
                  marginLeft: 16,
                  fontSize: 18,
                  marginTop: -12,
                }}
              >
                {item.form}
              </Typography>
              <Typography
                variant="h4"
                style={{
                  color: "black",
                  fontFamily: "Open Sans",
                  textAlign: "left",
                  marginLeft: 16,
                  fontSize: 18,
                  marginTop: 5,
                }}
              >
                {item.type}
              </Typography>
            </CardContent>
            <CardActions
              style={{
                display: "block",
                marginTop: "-10%",
                textAlign: "right",
              }}
            >
              <IconButton
                aria-label="edit"
                className={classes.button_size}
                onClick={() => this.goToProduct(item._id)}
                // component={Link}
                // to={{
                //   pathname: "/company/product",
                //   state: {
                //     itemId: item._id,
                //   },
                // }}
              >
                <EditIcon className={classes.edit_icon} />
              </IconButton>
              <IconButton aria-label="delete" className={classes.button_size}>
                <DeleteIcon
                  className={classes.edit_icon}
                  onClick={() => this.handleOpenDelete(item._id, item.brand_id)}
                />
              </IconButton>
            </CardActions>
          </Card>
        </Grid>
      );
    });

    return (
      <div className={classes.root}>
        <TopAppBar />
        <Typography
          component="h1"
          variant="h5"
          style={{
            color: "#F6277F",
            fontFamily: "Open Sans",
            marginLeft: "10%",
            marginBottom: "1%",
          }}
        >
          LEAF LIBRARY
        </Typography>
        <Grid
          container
          spacing={0}
          direction="row"
          alignItems="center"
          style={{ width: "100%", backgroundColor: "white" }}
        >
          <Grid item style={{ width: "80%", marginLeft: "9%" }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                id="demo-simple-select-outlined-label"
                style={{ marginTop: -6, color: "#707070" }}
              >
                Plant Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selected_plant}
                onChange={(text) => {
                  this.setState({ selected_plant: text.target.value });
                }}
                input={<OutlinedInput classes={{ input: classes.input }} />}
                className={classes.select}
                labelWidth={200}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {plant_type ? (
                  plant_type.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))
                ) : (
                  <MenuItem value={0}>Unexpected Error</MenuItem>
                )}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                id="demo-simple-select-outlined-label"
                style={{ marginTop: -6, color: "#707070" }}
              >
                Product Type
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selected_product}
                onChange={(text) => {
                  this.setState({ selected_product: text.target.value });
                }}
                className={classes.select}
                input={<OutlinedInput classes={{ input: classes.input }} />}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {product_type ? (
                  product_type.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))
                ) : (
                  <MenuItem value={0}>Unexpected Error</MenuItem>
                )}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                id="demo-simple-select-outlined-label"
                style={{ marginTop: -6, color: "#707070" }}
              >
                Cannabinoids
              </InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={selected_cana}
                onChange={(text) => {
                  this.setState({ selected_cana: text.target.value });
                }}
                className={classes.select}
                input={<OutlinedInput classes={{ input: classes.input }} />}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {cannabinoid ? (
                  cannabinoid.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))
                ) : (
                  <MenuItem value={0}>Unexpected Error</MenuItem>
                )}
              </Select>
            </FormControl>
            <Button
              style={{
                color: "black",
                border: "2px solid",
                borderColor: "#ababab",
                textTransform: "none",
              }}
              onClick={() => this.filterProduct()}
            >
              <SearchIcon className={classes.search_icon} />
            </Button>
          </Grid>
          <Grid item style={{ marginLeft: "-10%", width: "20%" }}>
            {/* {badgeCount === 0 ? null :  */}
            <Badge
              color="secondary"
              overlap="circle"
              badgeContent={badge_counter}
              style={{ marginRight: "2%" }}
            >
              <Button
                style={{
                  color: "black",
                  background: "#F8EFF3",
                  textTransform: "none",
                  fontFamily: "Open Sans",
                }}
                onClick={() => this.clearOptions()}
              >
                Clear
              </Button>
            </Badge>
            <Button
              component={Link}
              to="/company/product"
              style={{
                color: "white",
                background: "#F6227F",
                textTransform: "none",
                fontFamily: "Open Sans",
              }}
            >
              Add Product
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          style={{ marginTop: 20 }}
        >
          <Divider
            orientation="horizontal"
            style={{
              background: "#F6277F",
              height: 2,
              borderRadius: 20,
              width: "80%",
            }}
          />
        </Grid>
        {loading ? (
          <LinearProgress
            color="secondary"
            style={{ marginTop: "10%", marginBottom: "10%" }}
          />
        ) : !data.length ? (
          <Grid container spacing={0} justify="center" alignItems="center">
            <Typography
              component="h1"
              variant="h5"
              style={{
                textAlign: "center",
                fontFamily: "Open Sans",
                marginTop: "1%",
                minHeight: "60vh",
              }}
            >
              There are no products available with this filter, do you want to
              add a new product?
            </Typography>
          </Grid>
        ) : (
          <Grid
            container
            spacing={3}
            direction="row"
            justify="center"
            style={{
              minHeight: "70vh",
              maxWidth: "100%",
              paddingRight: 50,
              paddingLeft: 50,
            }}
          >
            {render_products}
            <Grid
              container
              spacing={3}
              direction="row"
              justify="center"
              style={{
                minHeight: "1vh",
                maxWidth: "100%",
                paddingRight: 50,
                paddingLeft: 50,
                margin: "2%",
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  this.handlePageClick(0);
                  this.clearOptions();
                }}
                style={{
                  color: "white",
                  background: "#F6227F",
                  textTransform: "none",
                  fontFamily: "Open Sans",
                  margin: "0.5%",
                  marginTop: "1%",
                }}
              >
                View All
              </Button>
              {page_numbers.length > 1 ? render_page : null}
            </Grid>
          </Grid>
        )}
        <Dialog
          open={dialog}
          onClose={this.handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Do you want to delete this product
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDelete} color="primary">
              No
            </Button>
            <Button onClick={() => this.deleteForm()} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Grid item align="center">
          <img
            alt=""
            style={{ height: 80, padding: 20, boxSizing: "unset" }}
            src={logo}
          />
        </Grid>
        <BottomBar />
      </div>
    );
  }
}

LeafLibrary.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(requireSub(withStyles(styles)(LeafLibrary)));
